/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiatePasscodeReset} from '../api'

export const useMutationInitiatePasscodeReset = createReactQueryMutationHook('initiatePasscodeReset', initiatePasscodeReset)
